import { useGlobalConfig } from '@ad-lucy/context/adData';

import { usePages } from '@ad-lucy/context/pages';
import { useLatest } from '@ad-lucy/hooks/utility';
import { LoggerService } from '@ad-lucy/services/LoggerService';
import { useCallback } from 'react';

import type { LiveRenderingSendMessage } from '../types';

const logger = LoggerService.getLogger().getModuleLogger(useSendMessage.name);

export function useSendMessage(): (message: LiveRenderingSendMessage) => void {
  const { currentPage } = usePages();
  const { data } = useGlobalConfig();
  const currentPageIdRef = useLatest(currentPage?.id);

  const { admCreative, campaign } = data || {};

  return useCallback(
    (message: LiveRenderingSendMessage) => {
      if (document.referrer) {
        try {
          const target = new URL(document.referrer).origin;
          window.parent.postMessage(
            {
              stage: currentPageIdRef.current,
              admCreative,
              campaign,
              source: 'creatives',
              ...message,
            },
            target,
          );
        } catch (e) {
          logger.error('Failed to send post message:', e);
        }
      }
    },
    [admCreative, campaign, currentPageIdRef],
  );
}
